var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":("/events?type=" + (_vm.status.code) + "&page=1"),"title":_vm.status.description}},[_c('b-badge',{attrs:{"variant":_vm._f("statusVariantFilter")(_vm.status)}},[_vm._v(_vm._s(_vm.status.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }